import { Ace } from 'ace-builds'

// Quick links for developers:
// - Ace Editor API (Editor instance used in onLoad): https://ace.c9.io/api/classes/src_editor.Editor.html
// - Ace API Reference (index): https://ace.c9.io/api/
// - React Ace docs (wrapper props like onLoad, onBeforeLoad, setOptions): https://securingsincity.github.io/react-ace/

export const getTableName = (value?: string) =>
	value === undefined ? undefined : value

export const getColumnName = (value?: string) =>
	value === undefined ? undefined : value

export const isTokenColumn = (value?: string) =>
	['.', '].', '].[', '].[]', '.[]'].includes(value ?? '')

interface ConfigureAceEditorOptions {
	isInModal?: boolean
}

export const configureAceEditor = (
	editor: Ace.Editor,
	options?: ConfigureAceEditorOptions,
) => {
	// Style tweaks
	const container = editor.container
	if (!options?.isInModal) {
		container.style.resize = 'both'
	}
	container.style.border = '1px solid #ccc'

	// Custom commands: copy only selected text
	const commandName = 'copySelectedTextOnly'

	editor.commands.addCommand({
		name: commandName,
		bindKey: { win: 'Ctrl-C', mac: 'Command-C' },
		exec: (ed) => {
			const text = ed.getSelectedText()
			if (text) {
				void navigator.clipboard.writeText(text)
			}
		},
	})

	window.addEventListener('mouseup', () => editor.resize())
}
